var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SellVisual'),_vm._v(" "),_c('SellMain',[_c('SellFormCasavo',{attrs:{"slot":"side"},slot:"side"}),_vm._v(" "),_c('SellBody',{attrs:{"slot":"body","show-message":_vm.doubleOptin},slot:"body"})],1),_vm._v(" "),_c('SellFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }